import { useNovel } from '@/context/novel-context';
import { useFirebase } from '@/firebase';

import { useCollaboratorManagement } from './use-collaborator-management';
import { useReaderManagement } from './use-reader-management';

export function useCollaboration() {
  const { novel, selectedNovel } = useNovel();
  if (!novel.id || !selectedNovel) {
    throw new Error('useCollaboration must be used within a NovelProvider with a loaded novel.');
  }

  const { user } = useFirebase();

  const isCurrentUserOwner = user?.uid === novel.ownerId;

  // Instantiate composed hooks for managing editors (collaborators)
  const collaboratorMgr = useCollaboratorManagement();

  // Instantiate composed hooks for managing readers (viewers)
  const readerMgr = useReaderManagement();

  return {
    user,
    isCurrentUserOwner,

    // Collaborators logic
    newCollabEmail: collaboratorMgr.newCollabEmail,
    setNewCollabEmail: collaboratorMgr.setNewCollabEmail,
    collabError: collaboratorMgr.collabError,
    isUpdatingCollab: collaboratorMgr.isUpdatingCollab,
    updatingCollabMemberId: collaboratorMgr.updatingMemberId,
    handleAddCollaborator: collaboratorMgr.handleAddCollaborator,
    handleRemoveCollaborator: collaboratorMgr.handleRemoveCollaborator,
    handleRemovePendingCollaborator: collaboratorMgr.handleRemovePendingCollaborator,

    // Readers logic
    newReaderEmail: readerMgr.newReaderEmail,
    setNewReaderEmail: readerMgr.setNewReaderEmail,
    readerError: readerMgr.readerError,
    isUpdatingReader: readerMgr.isUpdatingReader,
    updatingReaderMemberId: readerMgr.updatingMemberId,
    handleAddReader: readerMgr.handleAddReader,
    handleRemoveReader: readerMgr.handleRemoveReader,
    handleRemovePendingReader: readerMgr.handleRemovePendingReader,
  };
}
export default useCollaboration;
